import { WPublishedGoodsModel } from "./vo/w-published-goods.model";
import { WPublishedPageModel } from "./vo/w-published-page.model";

export class KYMW1422Model {
  koma = {
    orderCode: '',
    mediumType: '',
    coopCode: '',
    komaId: '',
    pageNum: '',
    pageInfo: ''
  };

  wPublishedGoodsList: WPublishedGoodsModel[] = [];
  wPublishedPageList: WPublishedPageModel[] = [];

  selectedPageRowIndex = -1;

  disabledRegister = true;

  public isKomaEmpty() {
    return Object.values(this.koma).some(value => value === '');
  }
}